import { create } from 'zustand';
import ServiceDocumentos from '@/services/ServiceDocumentos';
import { notify } from '@/stores/useToast';

type Item = any;

interface EnviarForm {
  nome: string;
  observacao?: string;
  cnpjs: string[];
  emails?: string[];
  file: File;
}
interface State {
  lista: Item[];
  total: number;
  carregando: boolean;
  buscar: () => Promise<void>;
  enviar: (form: EnviarForm) => Promise<boolean>;
  baixar: (id: string) => Promise<void>;
  excluir: (id: string) => Promise<void>;
}

export const useDocumentosStore = create<State>((set, get) => ({
  lista: [],
  total: 0,
  carregando: false,
  async buscar() {
    set({ carregando: true });
    try {
      const { data } = await ServiceDocumentos.listar({}, { page: 0, size: 50 });
      set({ lista: data.content ?? [], total: data.totalElements ?? 0 });
    } catch {
      notify.error('Erro ao buscar documentos.');
    } finally {
      set({ carregando: false });
    }
  },
  async enviar(form) {
    try {
      const { data: up } = await ServiceDocumentos.uploadUrl(
        form.file.type || 'application/octet-stream',
        form.file.name,
      );
      await ServiceDocumentos.enviarArquivo(up.url, form.file);
      await ServiceDocumentos.criar({
        nome: form.nome,
        observacao: form.observacao,
        cnpjs: form.cnpjs,
        emails: form.emails,
        key: up.key,
        contentType: form.file.type,
        size: form.file.size,
      });
      notify.success('Documento enviado.');
      await get().buscar();
      return true;
    } catch {
      notify.error('Erro ao enviar documento.');
      return false;
    }
  },
  async baixar(id) {
    try {
      const { data } = await ServiceDocumentos.downloadUrl(id);
      window.open(data.url, '_blank');
    } catch {
      notify.error('Erro ao baixar documento.');
    }
  },
  async excluir(id) {
    try {
      await ServiceDocumentos.excluir(id);
      notify.success('Documento excluído.');
      await get().buscar();
    } catch {
      notify.error('Erro ao excluir documento.');
    }
  },
}));
